import React, { useState } from 'react';

import Lottie from 'lottie-react';

import { ReactComponent as ThreeDotsIcon } from "assets/icons/ico_three_dots_green.svg";
import animSpinnerGreen from 'assets/animations/anim_spinner_green_40x40.json';

import TableItemContextMenu from 'components/dashboard/tableItemContextMenu/itemContextMenu';
import { useTranslation } from 'react-i18next';
import { useMessages } from 'context/messages';
import { getToken } from 'context/auth';
import { removeUserFromOrganization } from 'api/organizations';
import { useDashboard } from 'context/dashboard';

const OrganizationUserItem = ({user, users, setUsers, i, type}) => {

    const [isDeleting, setIsDeleting] = useState();
    const [showMenu, setShowMenu] = useState();
    const { t } = useTranslation();
    const { showModal, hideModal, showToast } = useMessages();
    const { organization } = useDashboard();

    const handleRemoveUserFromOrganization = async () => {
        setShowMenu(false);
        showModal(
            t('usersTable.removeUserTitle'),
            t('usersTable.removeUserDescription'),
            t('generic.yes'),
            async () => {
                setIsDeleting(true);
                hideModal();

                try {
                    const token = await getToken();
                    const removeUserFromOrganizationResult = await removeUserFromOrganization(token, { userExtId: user.userExtId, organizationExtId: organization.organizationExtId });

                    if (removeUserFromOrganizationResult && !removeUserFromOrganizationResult.error) {
                        /* Successful, remove item from list */
                        const newUsers = users.filter(({ userExtId }) => userExtId !== user.userExtId);
                        setUsers(newUsers);

                        showToast(t('usersTable.removedUserTitle'), t('usersTable.removedUserDescription'), 'success');
                    } else {
                        showToast(t('generic.errorTitle'), t('generic.errorDescription'), 'error');
                    }
                } catch (error) {
                    console.error(error);
                    showToast(t('generic.errorTitle'), t('generic.errorDescription'), 'error');
                }

                setIsDeleting(false);
            },
            t('generic.cancel'),
            () => { hideModal() },
            'warning');
    }

    return (
        <tr key={i} className="h-16 border-b-[1px] border-airpark-gray-300">
            <td className="pl-6 whitespace-nowrap">{user.firstName}</td>
            <td className="pl-6 whitespace-nowrap">{user.lastName}</td>
            <td className="pl-6 whitespace-nowrap">{user.email}</td>
            <td className="pl-6 whitespace-nowrap">{t('usersTable.'+type)}</td>
            <td className="border-l-[1px] border-airpark-gray-300 w-[72px] min-w-[72px] relative">
                {isDeleting &&
                    <div className="flex h-16 w-full justify-center items-center">
                        <Lottie className="h-6 w-6" animationData={animSpinnerGreen} loop={true} />
                    </div>
                }
                {!isDeleting &&
                    <button className="flex h-16 w-full justify-center items-center" onClick={(e) => { e.preventDefault(); setShowMenu(!showMenu); }}>
                        <ThreeDotsIcon className="block" />
                    </button>
                }
                {showMenu &&
                    <TableItemContextMenu
                        onCloseClick={() => { setShowMenu(false); }}
                        onDeleteClick={() => {
                            handleRemoveUserFromOrganization(user);
                        }}
                        deleteTitle={t('generic.remove')}>
                    </TableItemContextMenu>
                }
            </td>
        </tr>
    );
};

export default OrganizationUserItem;